import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Autocomplete, TextField } from "@mui/material";
import __ from "src/utils/Translations";
import { useCompanyId } from "src/Pages/Company/CompanyContext";
import useOrganizationUnits from "src/utils/hooks/company/useOrganizationUnits";

export const OrganizationUnitsAutocomplete = ({
  name,
  label,
}: {
  name: string;
  label: string;
}) => {
  const companyId = useCompanyId();

  const [opened, setOpened] = useState(false);

  const organizationUnits: { value: string; label: string }[] =
    useOrganizationUnits(
      true,
      "companyId" as unknown as null,
      companyId as unknown as null,
      false,
      !(companyId && opened)
    );

  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { onChange, ref, value },
        fieldState: { invalid, error },
      }) => (
        <Autocomplete
          options={organizationUnits || []}
          getOptionKey={(option) => option.value}
          getOptionLabel={(option) => option.label}
          isOptionEqualToValue={(option, selectedValue) =>
            String(option.value) === String(selectedValue.value)
          }
          value={
            (value && organizationUnits?.find((row) => row.value === value)) ??
            null
          }
          onChange={(_event, newValue) => {
            onChange(newValue?.value || null);
          }}
          onOpen={() => setOpened(true)}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              inputRef={ref}
              error={invalid}
              helperText={error?.message}
            />
          )}
        />
      )}
    />
  );
};
